export default __webpack_public_path__ + "static/media/logout.df327087.svg";